/**
 * Cookie名
 */
export const COOKIE_ADMIN_TYPE = "admin_type";
export const COOKIE_KEY_USER = "st_cid";
